
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 30"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"22.798","y1":"21.2","x2":"1.524","y2":"14.536"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})]),_c('path',{attrs:{"d":"M0 5.2V30h22.7V5.2H0zm21.3 23.5h-20V6.5h20v22.2z","fill":"url(#a)"}}),_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"29.288","y1":"14.308","x2":"6.51","y2":"7.173"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})]),_c('path',{attrs:{"fill":"url(#b)","d":"M4 0v1.3h22.7v26.1H28V0z"}}),_c('linearGradient',{attrs:{"id":"c","gradientUnits":"userSpaceOnUse","x1":"16.009","y1":"13.856","x2":"7.333","y2":"11.139"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})]),_c('path',{attrs:{"fill":"url(#c)","d":"M5.3 11.7h12V13h-12z"}}),_c('linearGradient',{attrs:{"id":"d","gradientUnits":"userSpaceOnUse","x1":"16.009","y1":"19.073","x2":"7.333","y2":"16.355"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})]),_c('path',{attrs:{"fill":"url(#d)","d":"M5.3 17h12v1.3h-12z"}}),_c('linearGradient',{attrs:{"id":"e","gradientUnits":"userSpaceOnUse","x1":"-366.988","y1":"311.602","x2":"-367.164","y2":"311.547","gradientTransform":"matrix(28 0 0 -30 10287 9370)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})]),_c('path',{attrs:{"fill":"url(#e)","d":"M5.3 22.2H12v1.3H5.3z"}})])
          )
        }
      }
    